import {
  DocumentNode,
  NetworkStatus,
  OperationVariables,
  QueryHookOptions,
  QueryResult,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client';
import { useFeatureToggle } from '@css-xp/base';
import { STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';

export const usePersistedCacheQuery = <TData = any, TVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options: QueryHookOptions<TData, TVariables>
): QueryResult<TData, TVariables> & { isNetworkCallHappening: boolean } => {
  const [isEnabled] = useFeatureToggle();
  const result = useQuery(query, {
    ...options,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  let isActuallyLoading = result.loading;
  if (isEnabled(STATSIG_FEATURE_GATES.ENABLE_GRAPHQL_CACHING)) {
    isActuallyLoading =
      [NetworkStatus.setVariables, NetworkStatus.fetchMore, NetworkStatus.refetch].includes(result.networkStatus) ||
      (result.loading &&
        !result.client.readQuery({
          query,
          variables: options?.variables,
        }));
  }

  return { ...result, loading: isActuallyLoading, isNetworkCallHappening: result.loading };
};
